import { RouterProvider } from 'react-router-dom'
import { useAuth } from '@/auth/useAuth'
import { LoginPage } from '@/features/auth/LoginPage'
import { LoadingState } from '@/ui'
import { router } from './routes'

export function App() {
  const { status } = useAuth()

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingState />
      </div>
    )
  }

  if (status === 'unauthenticated') {
    return <LoginPage />
  }

  return <RouterProvider router={router} />
}
